import { FarmDatasource } from "@farm/data/datasources/farm.datasource";
import { FarmMapper } from "@farm/data/mappers/farm.mapper";
import { LayerTypeMapper } from "@farm/data/mappers/layer-type.mapper";
import { LayerMapper } from "@farm/data/mappers/layer.mapper";
import { PlotMapper } from "@farm/data/mappers/plot.mapper";
import { FarmImplRepository } from "@farm/data/repositories/farm.impl-repository";
import type { FarmRepository } from "@farm/domain/repositories/farm.repository";
import { FarmAddPlotUseCase } from "@farm/domain/usecases/farm-add-plot.usecase";
import { FarmCreateUseCase } from "@farm/domain/usecases/farm-create.usecase";
import { FarmDeleteUseCase } from "@farm/domain/usecases/farm-delete.usecase";
import { FarmGetAllUseCase } from "@farm/domain/usecases/farm-get-all.usecase";
import { FarmGetByIdUseCase } from "@farm/domain/usecases/farm-get-by-id.usecase";
import { FarmUpdateUseCase } from "@farm/domain/usecases/farm-update.usecase";
import { LayerFetchUseCase } from "@farm/domain/usecases/layer-fetch.usecase";
import { LayerTypesGetAllUseCase } from "@farm/domain/usecases/layer-types-get-all.usecase";
import { PlotDeleteUseCase } from "@farm/domain/usecases/plot-delete.usecase";
import { PlotFileDeleteUseCase } from "@farm/domain/usecases/plot-file-delete.usecase";
import { PlotFileUploadUseCase } from "@farm/domain/usecases/plot-file-upload.usecase";
import { PlotUpdateUseCase } from "@farm/domain/usecases/plot-update.usecase";
import { farmTypes } from "@farm/farm-types.di";
import { FarmListViewmodel } from "@farm/presentation/components/list/farm-list.viewmodel";
import { FarmMapViewmodel } from "@farm/presentation/components/map/farm-map.viewmodel";
import { FarmCreateModalViewModel } from "@farm/presentation/components/modal/farm/create/farm-create-modal.viewmodel";
import { FarmUpdateModalViewModel } from "@farm/presentation/components/modal/farm/update/farm-update-modal.viewmodel";
import { PlotModalFormViewmodel } from "@farm/presentation/components/modal/plot/plot-modal-form.viewmodel";
import { PlotUpdateModalViewModel } from "@farm/presentation/components/modal/plot/update/plot-update-modal.viewmodel";
import { FarmWebPageViewmodel } from "@farm/presentation/pages/farm/farm-web.viewmodel";
import { DiModuleBuilder } from "@iot-platform/core";
import { ContainerModule } from "inversify";

const webFarmModule = new DiModuleBuilder();

webFarmModule.registerSubModules(() => ({
    datasources: new ContainerModule(({ bind }) => {
        bind(FarmDatasource).toSelf();
    }),
    mappers: new ContainerModule(({ bind }) => {
        bind(FarmMapper).toSelf();
        bind(PlotMapper).toSelf();
        bind(LayerTypeMapper).toSelf();
        bind(LayerMapper).toSelf();
    }),
    repositories: new ContainerModule(({ bind }) => {
        bind<FarmRepository>(farmTypes.repositories.FarmRepository).to(
            FarmImplRepository,
        );
    }),
    useCases: new ContainerModule(({ bind }) => {
        bind(FarmGetAllUseCase).toSelf();
        bind(FarmGetByIdUseCase).toSelf();
        bind(FarmCreateUseCase).toSelf();
        bind(FarmUpdateUseCase).toSelf();
        bind(FarmDeleteUseCase).toSelf();
        bind(FarmAddPlotUseCase).toSelf();
        bind(PlotDeleteUseCase).toSelf();
        bind(PlotFileDeleteUseCase).toSelf();
        bind(PlotFileUploadUseCase).toSelf();
        bind(PlotUpdateUseCase).toSelf();
        bind(LayerTypesGetAllUseCase).toSelf();
        bind(LayerFetchUseCase).toSelf();
    }),
    viewModels: new ContainerModule(({ bind }) => {
        bind(FarmListViewmodel).toSelf();
        bind(FarmMapViewmodel).toSelf();
        bind(FarmCreateModalViewModel).toSelf();
        bind(FarmUpdateModalViewModel).toSelf();
        bind(FarmWebPageViewmodel).toSelf();
        bind(PlotModalFormViewmodel).toSelf();
        bind(PlotUpdateModalViewModel).toSelf();
    }),
}));

webFarmModule.registerModule();

export { webFarmModule };
